import React, { useState, useEffect, useRef } from "react"
import MetaTags from "react-meta-tags"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
// import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { isEmpty } from "lodash"
import Select from "react-select"
import { useSelector } from "react-redux"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import api from "helpers/Api"
import SimpleReactValidator from "simple-react-validator"
//import { ToastContainer, toast } from "react-toastify"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { ToastContainer, toast } from "react-toastify"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Table,
  Spinner,
  Input,
  //Badge,
  //FormGroup,
  UncontrolledTooltip,

  // CardTitle
} from "reactstrap"
import ButtonSpinner from "../../components/ButtonSpinner"
import * as myObsLeadAction from "../../store/bXlvYnNsZWFk/actions"
import * as manageObsLeadAction from "../../store/bWFuYWdlb2JzbGVhZA/actions"
import Modal from "react-bootstrap/Modal"
import moment from "moment"

const MyObsLeadDetails = (props) => {
  const title = "My Obs Lead"
  //const { SearchBar} = Search
  const { dispatch, searchBtnStyle } = props

  const simpleValidator = useRef(new SimpleReactValidator())
  const simpleLeadValidator = useRef(new SimpleReactValidator())
  const simpleRejectValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()
  const [, leadForceUpdate] = useState()
  const [, rejectForceUpdate] = useState()

  //get agent id
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  //date format from localstorage
  const authUser = localStorage.getItem("authUser")
  const getId = JSON.parse(authUser)

  const setId =
    !isEmpty(getId) && getId.id
      ? getId.id
      : !isEmpty(user) && user.id
        ? user.id
        : ""

  const Id = setId ? setId : ""

  //date format from localstorage

  const dateLogin = JSON.parse(authUser)

  const setDate =
    !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.dateFormate
      ? dateLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
        ? user.setting.dateFormate.toUpperCase()
        : []

  const dateFormat = !isEmpty(setDate) && setDate ? setDate : ""
  const [applyFilter, setApplyFilter] = useState(false)
  const [applyDateFilter, setApplyDateFilter] = useState(false)
  console.log(Id, "agentid")

  function addZeroBefore(number) {
    var numberString = "0" + number
    if (number < 10) {
      return numberString
    } else {
      return number
    }
  }
  const currentDate = moment().format("YYYY-MM-DD")
  var currentDateMoment = moment().format("YYYY-MM-DD")
  var currentHourMoment = addZeroBefore(moment().format("HH"))
  var currentMinuteMoment = addZeroBefore(moment().minutes())
  var currentDateTimeMoment =
    currentDateMoment + "T" + currentHourMoment + ":" + currentMinuteMoment
  console.log(currentDateTimeMoment, "currentDateTimeMoment")
  // console.log(uploadInput, "myUpload")
  const firstDayOfMonth = moment().startOf("month").format("YYYY-MM-DD")
  useEffect(() => {
    // dispatch(myObsLeadAction.loadEmployee())
    dispatch(myObsLeadAction.loadRecordsMetaData())
    setObsMode({ label: "Other Brand Lead", value: 1 })
    dispatch(
      myObsLeadAction.loadMyObsList({
        agentId: Id,
        page: 1,
        mode: 1,
        limit: 100,
        fromDate: firstDayOfMonth,
        toDate: currentDate,
      })
    )
    dispatch(manageObsLeadAction.loadCompany())
    setFollowUpData({
      futureFollowUpDate: currentDateTimeMoment,
    })
    setApplyDateFilter(false)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      if (applyDateFilter === false) {
        setMyObsLeadData({
          ...myObsLeadData,
          fromDate: firstDayOfMonth,
          toDate: currentDate,
        })
      }
    }, 3000)
  }, [applyDateFilter])

  const update = useSelector((state) => state.myobslead)
  console.log(update, "update")
  console.log(currentDate, "currentDate")

  const {
    // employee_list = [],
    obsMetaData = {},
    obs_datalist,
    followup_list = [],
  } = update
  const companyUpdate = useSelector((state) => state.manageobslead)
  const { company_list = []} = companyUpdate
  const competitorCompanyOptions = company_list && !isEmpty(company_list) ?
   company_list.filter(m=>m.status == 1).map((company)=>{
    return{
      label:company.competitorCompanyName,
      value:company._id
    }
   }) : []
  // filter form initial state
  const [myObsLeadData, setMyObsLeadData] = useState({
    fromDate: "",
    toDate: "",
    followupFromDate: "",
    followupToDate: "",
    futureFollowupFromDate: "",
    futureFollowupToDate: "",
    rejectFromDate: "",
    rejectToDate: "",
    eventStartDate: "",
    eventEndDate: ""
  })

  console.log(myObsLeadData.fromDate, myObsLeadData.toDate, "toDate")
  //handle change
  const handleChange = async (e) => {
    setMyObsLeadData({ ...myObsLeadData, [e.target.name]: e.target.value })
  }
  //company
  const [competitorCompanyAdd, setCompetitorCompanyAdd] = useState(false)
  const [newCompetitorCompany, setNewCompetitorCompany] = useState("")
  const [competitorCompanyAdded, setCompetitorCompanyAdded] = useState(false)
  const handleCompetitorCompanyTab = () => {
    setCompetitorCompanyAdd(!competitorCompanyAdd)
  }
  const [competitorCompany, setCompetitorCompany] = useState([])
  const addCompetitorCompanyDetails = () => {
    setCompetitorCompanyAdded(true)
    setCompetitorCompanyAdd(false)
    const company_Details = {
       "competitorCompanyName": newCompetitorCompany.toUpperCase()
    }
    dispatch(manageObsLeadAction.addCompany(company_Details))
    setTimeout(() => {
      dispatch(manageObsLeadAction.loadCompany({status:1}))
      setCompetitorCompanyAdded(false)
    }, 700)
  }
  //mode data
  const [modeData, setModeData] = useState("")
  //dropdown initial state
  const [employee, setEmployee] = useState([])
  const [obsMode, setObsMode] = useState([])
  //employee options(agent options)

  //dropdown initial state
  const [company, setCompany] = useState([])
  const [branch, setBranch] = useState([])
  const [leadSource, setLeadSource] = useState([])
  const [salesUrge, setSalesUrge] = useState([])
  const [processStatus, setProcessStatus] = useState([])

  const branchOptions =
    !isEmpty(obsMetaData) && obsMetaData.branchOptions
      ? obsMetaData.branchOptions.filter(
        (branch) => branch.companyId === company.value
      )
      : []

  const resetForm = () => {
    setObsMode({ label: "Other Brand Lead", value: 1 })
    setEmployee([])
    setCompany([])
    setBranch([])
    setLeadSource([])
    setProcessStatus([])
    setSalesUrge([])
    setTimeout(() => {
      dispatch(
        myObsLeadAction.loadMyObsList({
          agentId: Id,
          page: 1,
          mode: 1,
          limit: 100,
          fromDate: firstDayOfMonth,
          toDate: currentDate,
        })
      )
    }, 2000)
    setMyObsLeadData({
      fromDate: firstDayOfMonth,
      toDate: currentDate,
      followupFromDate: "",
      followupToDate: "",
      futureFollowupFromDate: "",
      futureFollowupToDate: "",
      rejectFromDate: "",
      rejectToDate: "",
      eventStartDate: "",
      eventEndDate: ""

    })
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)

  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)

  const [searchValueList, setSearchValueList] = useState({})
  console.log(searchValueList, "searchValueList")

  const searchValue = !isEmpty(searchValueList)
    ? searchValueList
    : {
      agentId: Id,
      page: 1,
      mode: obsMode.value,
      limit: 100,
      fromDate: firstDayOfMonth,
      toDate: currentDate,
    }
  //filter
  const handleFilter = () => {
    // var searchEmployee = employee && employee ? employee.value : ""

    var searchFromDate =
      myObsLeadData && myObsLeadData.fromDate
        ? moment(myObsLeadData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      myObsLeadData && myObsLeadData.toDate
        ? moment(myObsLeadData.toDate).format("YYYY-MM-DD")
        : ""
    var searchFollowupFromDate =
      myObsLeadData && myObsLeadData.followupFromDate
        ? moment(myObsLeadData.followupFromDate).format("YYYY-MM-DD")
        : ""
    var searchFollowupToDate =
      myObsLeadData && myObsLeadData.followupToDate
        ? moment(myObsLeadData.followupToDate).format("YYYY-MM-DD")
        : ""
    var searchFutureFollowupFromDate =
      myObsLeadData && myObsLeadData.futureFollowupFromDate
        ? moment(myObsLeadData.futureFollowupFromDate).format("YYYY-MM-DD")
        : ""
    var searchFutureFollowupToDate =
      myObsLeadData && myObsLeadData.futureFollowupToDate
        ? moment(myObsLeadData.futureFollowupToDate).format("YYYY-MM-DD")
        : ""
    var searchRejectFromDate =
      myObsLeadData && myObsLeadData.rejectFromDate
        ? moment(myObsLeadData.rejectFromDate).format("YYYY-MM-DD")
        : ""
    var searchRejectToDate =
      myObsLeadData && myObsLeadData.rejectToDate
        ? moment(myObsLeadData.rejectToDate).format("YYYY-MM-DD")
        : ""
    var searchMode = obsMode && obsMode ? obsMode.value : ""
    var searchCompany = company && company ? company.value : ""
    var searchBranch = branch && branch ? branch.value : ""
    var searchSource = leadSource && leadSource ? leadSource.value : ""
    var searchSalesUrge = salesUrge && salesUrge ? salesUrge.value : ""
    var searchProcessStatus =
      processStatus && processStatus ? processStatus.value : ""
    var searchEventFromDate =
      myObsLeadData && myObsLeadData.eventStartDate
        ? moment(myObsLeadData.eventStartDate).format("YYYY-MM-DD")
        : ""
    var searchEventToDate =
      myObsLeadData && myObsLeadData.eventEndDate
        ? moment(myObsLeadData.eventEndDate).format("YYYY-MM-DD")
        : ""
    var searchFilter = {}
    searchFilter.page = pageChange ? pageCount : 1
    searchFilter.limit = 50
    // if (searchEmployee) {
    searchFilter.agentId = Id
    // }
    if (searchFromDate) {
      searchFilter.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchFilter.toDate = searchToDate
    }
    if (searchFollowupFromDate) {
      searchFilter.futureFollowupFrom = searchFollowupFromDate
    }
    if (searchFollowupToDate) {
      searchFilter.futureFollowupTo = searchFollowupToDate
    }
    if (searchFutureFollowupFromDate) {
      searchFilter.obsFutureFollowupFrom = searchFutureFollowupFromDate
    }
    if (searchFutureFollowupToDate) {
      searchFilter.obsFutureFollowupTo = searchFutureFollowupToDate
    }
    if (searchRejectFromDate) {
      searchFilter.rejectedLeadFrom = searchRejectFromDate
    }
    if (searchRejectToDate) {
      searchFilter.rejectedLeadTo = searchRejectToDate
    }
    if (searchMode) {
      searchFilter.mode = searchMode
    }
    if (searchCompany) {
      searchFilter.companyId = searchCompany
    }
    if (searchSource) {
      searchFilter.leadSourceId = searchSource
    }
    if (searchBranch) {
      searchFilter.branchId = searchBranch
    }
    if (searchSalesUrge) {
      searchFilter.salesUrge = searchSalesUrge
    }
    if (searchProcessStatus) {
      searchFilter.processStatus = searchProcessStatus
    }
    if (searchEventFromDate) {
      searchFilter.eventStartDate = searchEventFromDate
    }
    if (searchEventToDate) {
      searchFilter.eventEndDate = searchEventToDate
    }
    setSearchValueList(searchFilter)
    console.log("filter values", searchFilter)
    setModeData(obsMode.value)
    dispatch(myObsLeadAction.loadMyObsList(searchFilter))
    setPageLoad(!pageLoad)
    setBtnLoader(true)
    setBtnLoading(true)
    setApplyFilter(true)
    setTimeout(() => {
      setBtnLoader(false)
      setBtnLoading(false)
    }, 2000)
  }
  console.log(modeData, "modeData")
  console.log(applyFilter, "applyFilter")
  //dataTable
  // useEffect(() => {
  //   setTimeout(() => {
  //     if (applyFilter === false) {
  //       setMyObsLeadData({
  //         ...myObsLeadData,
  //         fromDate: myObsLeadData.fromDate,
  //         toDate: myObsLeadData.toDate,
  //       })
  //     }
  //   }, 3000)
  // }, [applyFilter])
  //followupmodal
  const [followUpModal, setFollowUpModal] = useState(false)

  useEffect(() => {
    setFollowUpData({
      ...followUpData,
      futureFollowUpDate: currentDateTimeMoment,
    })
  }, [followUpModal])
  //follow up history view modal
  const [followUpHistoryModal, setFollowUpHistoryModal] = useState(false)

  //dataTable
  const [dataFollowUp, setDataFollowUp] = useState("")
  //dropdown value fore mode
  const [mode, setMode] = useState([])
  const [rejectReason, setRejectReason] = useState([])

  let slNo = 0
  console.log(obs_datalist, "dataa")
  const myObsLeadDataTable = !isEmpty(obs_datalist)
    ? obs_datalist.data.map((obsdata, index) => {
      console.log(obs_datalist, "datais")

      const colorCode =
        !isEmpty(obsMetaData) &&
        obsMetaData.processStatusOptions &&
        obsMetaData.processStatusOptions.length > 0 &&
        obsMetaData.processStatusOptions.find(
          (_) => _.value === obsdata.processStatus
        ) &&
        obsMetaData.processStatusOptions.find(
          (_) => _.value === obsdata.processStatus
        ).colorCode

      const obsColor =
        !isEmpty(obsMetaData) &&
        obsMetaData.processStatusOptions &&
        obsMetaData.processStatusOptions.length > 0 &&
        obsMetaData.processStatusOptions.find(
          (_) => _.value === obsdata.obsStatus
        ) &&
        obsMetaData.processStatusOptions.find(
          (_) => _.value === obsdata.obsStatus
        ).colorCode
      slNo = slNo + 1
      const attachments =
        obsdata.rejectAttachment && obsdata.rejectAttachment.split(".").pop()

      const eventdates = !isEmpty(obsdata.eventDate)
        ? obsdata.eventDate.filter((date) => date !== null).map((m) => moment(m).format(dateFormat)).join(",")
        : "--"
      const eventName = !isEmpty(obsdata.eventName)
        ? obsdata.eventName.filter((m) => m !== null).map((m) => m).join(",")
        : "--"
      return {
        key: index,
        sNo: slNo,
        _id: obsdata._id,
        company: obsdata.companyName,
        budget: obsdata.budget,
        branch: obsdata.branchName,
        leadDate: obsdata.leadDate
          ? moment(obsdata.leadDate).format(dateFormat)
          : "",
        leadNo: obsdata.leadNo,
        clientCode: obsdata.clientCode,
        clientName: obsdata.clientName,
        contactNo: obsdata.clientNumber,
        emailId: obsdata.clientEmail,
        source: obsdata.leadSourceName,
        subSource: obsdata.leadSubSourceName ? obsdata.leadSubSourceName : "--",
        eventName: eventName,
        eventDate: eventdates,
        venue: obsdata.venueName,
        salesAgent: obsdata.obsAgentName,
        processStatus: (
          <button
            style={{
              background: colorCode,
              border: "none",
              cursor: "pointer",
              color: "white",
              padding: "2px",
              borderRadius: "4px",
            }}
          >
            {obsdata.processStatusName}
          </button>
        ),

        rejectedRemarks: obsdata.rejectedRemarks,
        rejectedReason: obsdata.rejectReasonName,
        rejectedBy: obsdata.rejectedBy,
        rejectedOn: obsdata.rejectedOn
          ? moment(obsdata.rejectedOn).format(dateFormat)
          : "",
        rejectedAttachment:
          (obsdata.rejectAttachment && attachments === "jpeg") ||
            (obsdata.rejectAttachment && attachments === "jpg") ||
            (obsdata.rejectAttachment && attachments === "png") ? (
            <a
              onClick={() => window.open(obsdata.rejectAttachment, "_blank")}
            >
              <span
                style={{
                  textDecoration: "underline",
                  color: "#E40D8C",
                }}
              >
                View Attachments
              </span>
            </a>
          ) : (obsdata.rejectAttachment && attachments === "mp3") ||
            (obsdata.rejectAttachment && attachments === "m4a") ||
            (obsdata.rejectAttachment && attachments === "mp4") ? (
            <a href={obsdata.rejectAttachment}>
              <audio controls>
                <source src={obsdata.rejectAttachment} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            </a>
          ) : (
            ""
          ),

        obsAgent: obsdata.salesAgentName,
        futureFollowUpDate: obsdata.futureFollowupDate
          ? moment(obsdata.futureFollowupDate).format(dateFormat)
          : "--",
        followup: (
          <Button
            className="btn btn-info"
            onClick={() => {
              setFollowUpModal(true)
              setMode({ label: "Followup", value: "followup" })
              setDataFollowUp(obsdata)
              clearData()
              setUploadInput([])
              setAttachmentFile([])
              setUploadAttachment([])
            }}
          >
            Follow Up
          </Button>
        ),
        followUpHistory: (
          <p
            className="text-decoration-underline text-info"
            onClick={() => {
              setFollowUpHistoryModal(true)
              dispatch(myObsLeadAction.loadFollowUp({ leadId: obsdata._id }))
            }}
          >
            History
          </p>
        ),
        obsStatus: !isEmpty(obsdata.obsStatus) ? (
          <button
            style={{
              background: obsColor,
              border: "none",
              cursor: "pointer",
              color: "white",
              padding: "2px",
              borderRadius: "4px",
            }}
          >
            {obsdata.obsStatusName}
          </button>
        ) : (
          <button
            style={{
              background: "#862D59",
              border: "none",
              cursor: "pointer",
              color: "white",
              padding: "2px",
              borderRadius: "4px",
            }}
          >
            {"Pending"}
          </button>
        ),
      }
    })
    : []

  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "company",
      text: "Company",
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "branch",
      text: "Branch",
      //sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "leadDate",
      text: "Lead Date",
      csvType: Number,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      headerStyle: {
        minWidth: "155px",
      },
    },
    // {
    //   dataField: "clientCode",
    //   text: "Client Code",

    //   headerStyle: {
    //     minWidth: "145px",
    //   },
    // },
    {
      dataField: "clientName",
      text: "Client Name",

      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "contactNo",
      text: "Contact No",
      csvType: Number,
      headerStyle: {
        minWidth: "160px",
      },
    },
    // {
    //   dataField: "emailId",
    //   text: "Email Id",

    //   headerStyle: {
    //     minWidth: "160px",
    //   },
    // },
    {
      dataField: "source",
      text: "Source",

      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "subSource",
      text: "Sub Source",

      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      csvType: Number,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "budget",
      text: "Budget",
      csvType: Number,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "venue",
      text: "Venue",

      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "salesAgent",
      text: "Sales Agent",

      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "processStatus",
      text: "Process Status",
      hidden: modeData === 2 ? true : false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "rejectedRemarks",
      text: "Rejected Remarks",
      hidden: modeData === 2 ? false : true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    // {
    //   dataField: "rejectedReason",
    //   text: "Rejected Reason ",
    //   hidden: modeData === 2 ? false : true,
    //   headerStyle: {
    //     minWidth: "160px",
    //   },
    // },
    // {
    //   dataField: "rejectedBy",
    //   text: "Rejected By",
    //   hidden: modeData === 2 ? false : true,
    //   headerStyle: {
    //     minWidth: "160px",
    //   },
    // },
    {
      dataField: "rejectedOn",
      text: "Rejected On ",
      hidden: modeData === 2 ? false : true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "rejectedAttachment",
      text: "Rejected Attachment",
      csvExport: false,
      hidden: modeData === 2 ? false : true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "obsAgent",
      text: "Obs Agent",

      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "futureFollowUpDate",
      text: "Future Followup Date",
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "followup",
      text: "Followup",
      csvExport: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "followUpHistory",
      text: "Followup History",
      csvExport: false,
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "obsStatus",
      text: "OBS status",
      csvExport: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
  ]
  //download feature in data table

  const [downloadLoading, setDownloadLoading] = useState(false)
  /////
  const [loading, setLoading] = useState(false)
  const MySearch = (props) => {
    let input

    const handleClick = () => {
      props.onSearch(input.value)
      console.log(input.value, "inputs")

      dispatch(
        myObsLeadAction.loadMyObsList({
          searchFilter: input.value,
          page: pageChange ? pageCount : 1,
          limit: 100,
          mode: obsMode.value,
          agentId: Id,
        })
      )
      console.log(input.value, "input")
    }

    return (
      <div className="d-flex flex-row">
        <input
          className="form-control"
          placeholder="Search"
          ref={(n) => (input = n)}
          type="text"
        />
        <button className="btn btn-success mx-2" onClick={handleClick}>
          <i className="fas fa-search"></i>
        </button>
      </div>
    )
  }
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  const exportToCsv = () => {
    if (
      !isEmpty(employee) ||
      !isEmpty(branch) ||
      !isEmpty(company) ||
      !isEmpty(obsMode) ||
      !isEmpty(salesUrge) ||
      !isEmpty(processStatus) ||
      !isEmpty(myObsLeadData.fromDate) ||
      !isEmpty(myObsLeadData.toDate) ||
      !isEmpty(myObsLeadData.eventStartDate) ||
      !isEmpty(myObsLeadData.eventEndDate) ||
      !isEmpty(myObsLeadData.followupFromDate) ||
      !isEmpty(myObsLeadData.followupToDate) ||
      !isEmpty(myObsLeadData.futureFollowupFromDate) ||
      !isEmpty(myObsLeadData.futureFollowupToDate) ||
      !isEmpty(myObsLeadData.rejectFromDate) ||
      !isEmpty(myObsLeadData.rejectToDate)
    ) {
      var searchFromDate =
        myObsLeadData && myObsLeadData.fromDate
          ? moment(myObsLeadData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        myObsLeadData && myObsLeadData.toDate
          ? moment(myObsLeadData.toDate).format("YYYY-MM-DD")
          : ""
      var searchFollowupFromDate =
        myObsLeadData && myObsLeadData.followupFromDate
          ? moment(myObsLeadData.followupFromDate).format("YYYY-MM-DD")
          : ""
      var searchFollowupToDate =
        myObsLeadData && myObsLeadData.followupToDate
          ? moment(myObsLeadData.followupToDate).format("YYYY-MM-DD")
          : ""
      var searchFutureFollowupFromDate =
        myObsLeadData && myObsLeadData.futureFollowupFromDate
          ? moment(myObsLeadData.futureFollowupFromDate).format("YYYY-MM-DD")
          : ""
      var searchFutureFollowupToDate =
        myObsLeadData && myObsLeadData.futureFollowupToDate
          ? moment(myObsLeadData.futureFollowupToDate).format("YYYY-MM-DD")
          : ""
      var searchRejectFromDate =
        myObsLeadData && myObsLeadData.rejectFromDate
          ? moment(myObsLeadData.rejectFromDate).format("YYYY-MM-DD")
          : ""
      var searchRejectToDate =
        myObsLeadData && myObsLeadData.rejectToDate
          ? moment(myObsLeadData.rejectToDate).format("YYYY-MM-DD")
          : ""
      var searchMode = obsMode && obsMode ? obsMode.value : ""
      var searchCompany = company && company ? company.value : ""
      var searchBranch = branch && branch ? branch.value : ""
      var searchSource = leadSource && leadSource ? leadSource.value : ""
      var searchSalesUrge = salesUrge && salesUrge ? salesUrge.value : ""
      var searchProcessStatus =
        processStatus && processStatus ? processStatus.value : ""
      var searchEventFromDate =
        myObsLeadData && myObsLeadData.eventStartDate
          ? moment(myObsLeadData.eventStartDate).format("YYYY-MM-DD")
          : ""
      var searchEventToDate =
        myObsLeadData && myObsLeadData.eventEndDate
          ? moment(myObsLeadData.eventEndDate).format("YYYY-MM-DD")
          : ""
      var searchFilter = {}

      // if (searchEmployee) {
      searchFilter.agentId = Id
      // }
      if (searchFromDate) {
        searchFilter.fromDate = searchFromDate
      }
      if (searchToDate) {
        searchFilter.toDate = searchToDate
      }
      if (searchFollowupFromDate) {
        searchFilter.futureFollowupFrom = searchFollowupFromDate
      }
      if (searchFollowupToDate) {
        searchFilter.futureFollowupTo = searchFollowupToDate
      }
      if (searchFutureFollowupFromDate) {
        searchFilter.obsFutureFollowupFrom = searchFutureFollowupFromDate
      }
      if (searchFutureFollowupToDate) {
        searchFilter.obsFutureFollowupTo = searchFutureFollowupToDate
      }
      if (searchRejectFromDate) {
        searchFilter.rejectedLeadFrom = searchRejectFromDate
      }
      if (searchRejectToDate) {
        searchFilter.rejectedLeadTo = searchRejectToDate
      }
      if (searchMode) {
        searchFilter.mode = searchMode
      }
      if (searchCompany) {
        searchFilter.companyId = searchCompany
      }
      if (searchSource) {
        searchFilter.leadSourceId = searchSource
      }
      if (searchBranch) {
        searchFilter.branchId = searchBranch
      }
      if (searchSalesUrge) {
        searchFilter.salesUrge = searchSalesUrge
      }
      if (searchProcessStatus) {
        searchFilter.processStatus = searchProcessStatus
      }
      if (searchEventFromDate) {
        searchFilter.eventStartDate = searchEventFromDate
      }
      if (searchEventToDate) {
        searchFilter.eventEndDate = searchEventToDate
      }
      console.log("filter values", searchFilter)
      setPageLoad(!pageLoad)

      setDownloadLoading(true)
      api
        .post(`/get_obs_others_and_rejected_excel_export_details`, searchFilter)
        .then((response) => {
          const followupExportDataTable = !isEmpty(response.data.data)
            ? response.data.data.map((data, index) => {

              const eventNameList = !isEmpty(data.eventName)
                ? data.eventName.map((m) => m).join(",")
                : "--"
              const eventName = JSON.stringify(eventNameList).replace(
                /","/g,
                "\n"
              )
              console.log(eventName, "eventName")
              const eventdates = !isEmpty(data.eventDate)
                ? data.eventDate.filter((m) => m !== null)
                  .map((m) => moment(m).format(dateFormat))
                  .join(",")
                : ""
              const eventDate = JSON.stringify(eventdates).replace(
                /","/g,
                "\n"
              )

              const salesAgent = JSON.stringify(data.salesAgentName).replace(
                /","/g,
                "\n"
              )

              const rejectedRemarks = !isEmpty(data.rejectedRemarks)
                ? data.rejectedRemarks.replace(/[\r\n,.]/gm, "")
                : "--"
              const venueName = Array.isArray(data.venueName) && data.venueName.length > 0
                ? data.venueName.map(m => m).join(",")
                : typeof data.venueName === 'string'
                  ? ""
                  : ""
              const venueNameValue = !isEmpty(venueName) ? JSON.stringify(venueName).replace(
                /","/g,
                "\n"
              ) : "--"
              console.log(rejectedRemarks, "rejectedRemarks")
              return {
                key: index,
                sNo: index + 1,
                _id: data._id,
                company: data.companyName ? data.companyName : "--",
                branch: data.branchName ? data.branchName : "--",
                leadDate: data.leadDate
                  ? moment(data.leadDate).format(dateFormat)
                  : "--",
                leadNo: data.leadNo ? data.leadNo : "--",
                clientCode: data.clientCode ? data.clientCode : "--",
                clientName: data.clientName ? data.clientName : "--",
                contactNo: data.clientNumber ? data.clientNumber : "--",
                emailId: data.clientEmail ? data.clientEmail : "--",
                source: data.leadSourceName ? data.leadSourceName : "--",
                subSource: data.leadSubSourceName ? data.leadSubSourceName : "--",
                eventName: eventName,
                eventDate: eventDate,
                venue: venueNameValue,
                budget: !isEmpty(data.budget) ? data.budget : 0,
                salesAgent: salesAgent,
                processStatusName: data.processStatusName ? data.processStatusName : "--",
                processStatus: data.processStatusName,
                manageObsStatus: data.processStatus,
                rejectedRemarks: !isEmpty(data.rejectedRemarks) ? rejectedRemarks : "--",
                rejectedReason: data.rejectedReason ? data.rejectReason : "--",
                rejectedBy: data.rejectedByName ?
                  data.rejectedByName : "--",
                rejectedOn: data.rejectedOn
                  ? moment(data.rejectedOn).format(dateFormat)
                  : "--",
                rejectedAttachment: data.rejectAttachment,
                // futureFollowUpDate:data.futureFollowupDate?data.futureFollowupDate.map(m=>moment(m).format(dateFormat)).join(","):"--",
                futureFollowUpDate: !isEmpty(data.futureFollowupDate)
                  ? moment(data.futureFollowupDate).format(dateFormat)
                  : "--",

                obsAgent:
                  data.obsAgentName != null ? data.obsAgentName : "--",

                obsStatus:
                  !isEmpty(data.obsStatus) || data.obsStatus != null
                    ? data.obsStatusName
                    : "Pending",
                manageObsStatusId: data.obsStatusName,
                obsStatusName:
                  data.obsStatusName != null ? data.obsStatusName : "--",
              }
            })
            : []
          setTimeout(() => {
            let headerData = [
              `SNo, Company , Branch ,Lead Date,Lead No, Client Name,Contact No, Source,Sub Source, Event Name,Event Date,Budget, Venue, Sales Agent, ${obsMode.value == 1
                ? "Process Status,"
                : ""
              } ${obsMode.value != 1
                ? "Rejected Remarks, Rejected On,"
                : ""
              }Obs Agent,Future FollowupDate, OBS Status`,
            ]


            let usersCsv = followupExportDataTable.reduce((acc, user) => {
              if (obsMode.value != 1) {
                const {
                  sNo,
                  company,
                  branch,
                  leadDate,
                  leadNo,
                  clientName,
                  contactNo,
                  source,
                  subSource,
                  eventName,
                  eventDate,
                  budget,
                  venue,
                  salesAgent,
                  rejectedRemarks,
                  rejectedOn,
                  obsAgent,
                  futureFollowupDate,
                  // followup,
                  // followupHistory,
                  obsStatus,
                } = user

                acc.push([
                  sNo,
                  company,
                  branch,
                  leadDate,
                  leadNo,
                  clientName,
                  contactNo,
                  source,
                  subSource,
                  eventName,
                  eventDate,
                  budget,
                  venue,
                  salesAgent,
                  rejectedRemarks,
                  rejectedOn,
                  obsAgent,
                  futureFollowupDate,
                  // followup,
                  // followupHistory,
                  obsStatus,
                ])
              } else {
                const {
                  sNo,
                  company,
                  branch,
                  leadDate,
                  leadNo,
                  clientName,
                  contactNo,
                  source,
                  subSource,
                  eventName,
                  eventDate,
                  budget,
                  venue,
                  salesAgent,
                  processStatus,
                  obsAgent,
                  futureFollowupDate,
                  obsStatus,
                } = user

                acc.push([
                  sNo,
                  company,
                  branch,
                  leadDate,
                  leadNo,
                  clientName,
                  contactNo,
                  source,
                  subSource,
                  eventName,
                  eventDate,
                  budget,
                  venue,
                  salesAgent,
                  processStatus,
                  obsAgent,
                  futureFollowupDate,
                  obsStatus,
                ])
              }

              console.log("test", acc)
              return acc
            }, [])
            console.log(usersCsv, "usersCsv")
            downloadFile({
              data: [...headerData, ...usersCsv].join("\n"),
              fileName: "MyObsLead.csv",
              fileType: "text/csv",
            })
            setDownloadLoading(false)
          }, 1000)

          return response.data
        })
        .catch((error) => {
          Promise.reject(error)
          setDownloadLoading(false)
        })

    }
  }
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {(props) => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4">
                        <div className="d-flex flex-row ">
                          <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                            <div
                              className="position-relative mt-7"
                              style={searchBtnStyle || null}
                            >
                              <MySearch {...props.searchProps} />
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </div>{" "}
                      </Col>
                      {/* {downloadAccessId === "61bc3079e2e60e9919697604" ? ( */}
                      <Col md="8">
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          {/* <ReactHTMLTableToExcel
                            // id="download1"

                            table="ImportTable"
                            filename={"manage followup"}
                            className={
                              "download-table-xls-button btn btn-primary mx-2"
                            }
                            sheet="tablexls"
                            buttonText="Download"
                          /> */}
                          {/* <ExportJsonCsv
                            onClick={(data) => console.log(data)}
                            headers={headers}
                            items={followupDataTable}
                          >
                            Export
                          </ExportJsonCsv> */}
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          // {...props.baseProps}
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone
                            // paginationTotalRenderer={leave_list.totalDataCount}
                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: obs_datalist.length,
    data:
      !isEmpty(obs_datalist) && obs_datalist.length > 0
        ? obs_datalist.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    console.log(page, "page")
    let result =
      !isEmpty(obs_datalist) && obs_datalist.length > 0 ? obs_datalist : []
    if (
      !isEmpty(employee) ||
      !isEmpty(myObsLeadData.fromDate) ||
      !isEmpty(myObsLeadData.toDate) ||
      !isEmpty(myObsLeadData.followupFromDate) ||
      !isEmpty(myObsLeadData.followupToDate) ||
      !isEmpty(myObsLeadData.futureFollowupFromDate) ||
      !isEmpty(myObsLeadData.futureFollowupToDate) ||
      !isEmpty(myObsLeadData.rejectFromDate) ||
      !isEmpty(myObsLeadData.rejectToDate) ||
      !isEmpty(myObsLeadData.eventStartDate) ||
      !isEmpty(myObsLeadData.eventEndDate) ||
      !isEmpty(obsMode) ||
      !isEmpty(company) ||
      !isEmpty(branch) ||
      !isEmpty(salesUrge) ||
      !isEmpty(processStatus)
    ) {
      // var searchEmployee = employee && employee ? employee.value : ""

      var searchFromDate =
        myObsLeadData && myObsLeadData.fromDate
          ? moment(myObsLeadData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        myObsLeadData && myObsLeadData.toDate
          ? moment(myObsLeadData.toDate).format("YYYY-MM-DD")
          : ""
      var searchFollowupFromDate =
        myObsLeadData && myObsLeadData.followupFromDate
          ? moment(myObsLeadData.followupFromDate).format("YYYY-MM-DD")
          : ""
      var searchFollowupToDate =
        myObsLeadData && myObsLeadData.followupToDate
          ? moment(myObsLeadData.followupToDate).format("YYYY-MM-DD")
          : ""
      var searchFutureFollowupFromDate =
        myObsLeadData && myObsLeadData.futureFollowupFromDate
          ? moment(myObsLeadData.futureFollowupFromDate).format("YYYY-MM-DD")
          : ""
      var searchFutureFollowupToDate =
        myObsLeadData && myObsLeadData.futureFollowupToDate
          ? moment(myObsLeadData.futureFollowupToDate).format("YYYY-MM-DD")
          : ""
      var searchRejectFromDate =
        myObsLeadData && myObsLeadData.rejectFromDate
          ? moment(myObsLeadData.rejectFromDate).format("YYYY-MM-DD")
          : ""
      var searchRejectToDate =
        myObsLeadData && myObsLeadData.rejectToDate
          ? moment(myObsLeadData.rejectToDate).format("YYYY-MM-DD")
          : ""
      var searchEventFromDate =
        myObsLeadData && myObsLeadData.eventStartDate
          ? moment(myObsLeadData.eventStartDate).format("YYYY-MM-DD")
          : ""
      var searchEventToDate =
        myObsLeadData && myObsLeadData.eventEndDate
          ? moment(myObsLeadData.eventEndDate).format("YYYY-MM-DD")
          : ""
      var searchMode = obsMode && obsMode ? obsMode.value : ""
      var searchCompany = company && company ? company.value : ""
      var searchBranch = branch && branch ? branch.value : ""
      var searchSalesUrge = salesUrge && salesUrge ? salesUrge.value : ""
      var searchProcessStatus =
        processStatus && processStatus ? processStatus.value : ""
      var searchSource = leadSource && leadSource ? leadSource.value : ""
      var searchFilter = {}
      searchFilter.page = pageChange ? pageCount : 1
      searchFilter.limit = 50
      // if (searchEmployee) {
      searchFilter.agentId = Id
      // }
      if (searchFromDate) {
        searchFilter.fromDate = searchFromDate
      }
      if (searchToDate) {
        searchFilter.toDate = searchToDate
      }
      if (searchFollowupFromDate) {
        searchFilter.futureFollowupFrom = searchFollowupFromDate
      }
      if (searchFollowupToDate) {
        searchFilter.futureFollowupTo = searchFollowupToDate
      }
      if (searchFutureFollowupFromDate) {
        searchFilter.obsFutureFollowupFrom = searchFutureFollowupFromDate
      }
      if (searchFutureFollowupToDate) {
        searchFilter.obsFutureFollowupTo = searchFutureFollowupToDate
      }
      if (searchRejectFromDate) {
        searchFilter.rejectedLeadFrom = searchRejectFromDate
      }
      if (searchRejectToDate) {
        searchFilter.rejectedLeadTo = searchRejectToDate
      }
      if (searchMode) {
        searchFilter.mode = searchMode
      }
      if (searchCompany) {
        searchFilter.companyId = searchCompany
      }
      if (searchBranch) {
        searchFilter.branchId = searchBranch
      }
      if (searchSource) {
        searchFilter.leadSourceId = searchSource
      }
      if (searchSalesUrge) {
        searchFilter.salesUrge = searchSalesUrge
      }
      if (searchProcessStatus) {
        searchFilter.processStatus = searchProcessStatus
      }
      if (searchEventFromDate) {
        searchFilter.eventStartDate = searchEventFromDate
      }
      if (searchEventToDate) {
        searchFilter.eventEndDate = searchEventToDate
      }
      setPageLoad(!pageLoad)
      console.log("searchCompany", searchFilter)
      setLoading(true)
      dispatch(myObsLeadAction.loadMyObsList(searchFilter))
    } else {
      dispatch(
        myObsLeadAction.loadMyObsList({
          page: page,
          limit: sizePerPage,
          mode: obsMode.value,
          agentId: Id,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  //followup modal data
  const [followUpData, setFollowUpData] = useState({
    followUpDate: "",
    time: "",
    reachStatus: "",
    followUpRemarks: "",
    rejectfollowUpRemarks: "",
    leadfollowUpRemarks: "",
    attachment: [],
    futureFollowUpDate: "",
  })
  //handle change

  const handleFollowUpChange = async (e) => {
    setFollowUpData({ ...followUpData, [e.target.name]: e.target.value })
  }

  //folowwup dropdown initial state
  const [followUpMode, setFollowUpMode] = useState([])
  const [rejectedFollowupMode, setRejectedFollowupMode] = useState([])
  const [leadFollowupMode, setLeadFollowupMode] = useState([])
  const [futureFollowUpMode, setFutureFollowUpMode] = useState([])
  const [followUpStatus, setFollowUpStatus] = useState([])
  const [rejectedFollowUpStatus, setRejectedFollowUpStatus] = useState([])
  const [leadFollowUpStatus, setLeadFollowUpStatus] = useState([])
  const [followUpStrategy, setFollowUpStrategy] = useState([])

  const [uploadInput, setUploadInput] = useState([])
  const [attachmentFile, setAttachmentFile] = useState([])
  const [uploadAttachment, setUploadAttachment] = useState([])

  const [fileName, setFileName] = useState("")
  const [fileLength, setFileLength] = useState("")
  const [attachFileName, setAttachFileName] = useState("")
  const [attachFileLength, setAttachFileLength] = useState("")
  const [uploadFileName, setUploadFileName] = useState("")
  const [uploadFileLength, setUploadFileLength] = useState("")

  console.log(fileName, attachFileName, uploadFileName, "attachment files")
  console.log(fileName, attachFileName, uploadFileName, "attachment files")
  console.log(
    followUpMode,
    futureFollowUpMode,
    followUpStatus,
    followUpStrategy,
    "select attachment files"
  )
  const uploadChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      setUploadInput(e.target.files)
      var file = e.target.files
      setFileName(file[0].name)
      setFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadInput(teamUploadValue)
          }
        })
      }
    }
  }
  const attachmentChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      setAttachmentFile(e.target.files)
      var file = e.target.files
      setAttachFileName(file[0].name)
      setAttachFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = attachmentFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setAttachmentFile(teamUploadValue)
          }
        })
      }
    }
  }

  const fileChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      setUploadAttachment(e.target.files)
      var file = e.target.files
      setUploadFileName(file[0].name)
      setUploadFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadAttachment(teamUploadValue)
          }
        })
      }
    }
  }

  // console.log(currentDate, "currentDate")

  const currentTime = moment().format("LT")
  // console.log(currentTime)

  // const currentdateTime = moment().format("YYYY-MM-DD LT")
  // console.log(currentdateTime, "datetime")

  //initial state for crosspromotion
  const [crossPromotionData, setCrossPromotionData] = useState([
    {
      company: "",
      companyId: "",
      branch: "",
      branchId: "",
      serviceId: "",
      service: "",
      followUpRemarks: "",
      convertSalesUrge: "",
      convertSalesUrgeId: ""
    },
  ])
  const [renderPage, setRenderPage] = useState(false)
  // const [addPromotions, setAddPromotions] = useState(false)
  const addCrossPromotion = async () => {
    setCrossPromotionData([
      ...crossPromotionData,
      {
        company: "",
        companyId: "",
        branch: "",
        branchId: "",
        serviceId: "",
        service: "",
        followUpRemarks: "",
        convertSalesUrge: "",
        convertSalesUrgeId: ""
      },
    ])
    setRenderPage(!renderPage)
    // setAddPromotions(false)
  }
  console.log(followUpData, "followupdata")
  const clearData = () => {
    setFollowUpMode([])
    setLeadFollowupMode([])
    setRejectReason([])
    setRejectedFollowupMode([])
    setCheckOption({ option: "", checked: "" })
    setRadioOption({ option: "", checked: "" })
    setReachOption({ option: "", checked: "" })
    setFlagOption({ option: "", checked: "" })
    setFileName("")
    setFileLength("")
    setAttachFileName("")
    setAttachFileLength("")
    setUploadFileName("")
    setUploadFileLength("")
    setFollowUpData({ ...followUpData, followUpRemarks: "", leadfollowUpRemarks: "", rejectfollowUpRemarks: "" })
    setFollowUpStatus([])
    setLeadFollowUpStatus([])
    setRejectedFollowUpStatus([])
    setFutureFollowUpMode([])
    setFollowUpStrategy([])
    setCrossPromotionData()
    setCrossPromotionData([
      {
        ...crossPromotionData,
        company: "",
        companyId: "",
        branch: "",
        branchId: "",
        serviceId: "",
        service: "",
        followUpRemarks: "",
        convertSalesUrge: "",
        convertSalesUrgeId: ""
      },
    ])
  }

  const modalChange = async (e, index, name) => {
    var crossPromotionList = crossPromotionData
    if (name == "followUpRemarks") {
      e = e.target.value
      crossPromotionList[index][name] = e
      setCrossPromotionData(crossPromotionList)
    }

    if (name == "companyId") {
      crossPromotionList[index]["companyId"] = e.value
      crossPromotionList[index]["company"] = e.label
      setCrossPromotionData(crossPromotionList)
    }
    if (name == "branchId") {
      crossPromotionList[index]["branchId"] = e.value
      crossPromotionList[index]["branch"] = e.label
      setCrossPromotionData(crossPromotionList)
    }
    if (name == "serviceId") {
      crossPromotionList[index]["serviceId"] = e.value
      crossPromotionList[index]["service"] = e.label
      setCrossPromotionData(crossPromotionList)
    }
    if (name == "convertSalesUrgeId") {
      crossPromotionList[index]["convertSalesUrgeId"] = e.value
      crossPromotionList[index]["convertSalesUrge"] = e.label
      setCrossPromotionData(crossPromotionList)
    }
    setRenderPage(!renderPage)
  }
  const removeCrossPromotion = async (toRemove) => {
    var crossPromotionList = crossPromotionData
    if (toRemove != 0) {
      if (toRemove > -1) {
        crossPromotionList.splice(toRemove, 1)
      }
      setCrossPromotionData(crossPromotionList)
      setRenderPage(!renderPage)
    }
  }
  const promotionData =
    !isEmpty(crossPromotionData) && crossPromotionData.length > 0
      ? crossPromotionData.map((data) => {
        if (data) {
          return {
            companyId: data.companyId,
            branchId: data.branchId,
            serviceId: data.serviceId,
            remarks: data.followUpRemarks,
            salesUrge: data.convertSalesUrgeId,
            action: true,
          }
        }
      })
      : []

  const submitCrossPromotion = () => {
    if (mode.value === "followup") {
      if (simpleValidator.current.allValid()) {
        const submitFollowUp = {
          followupNo: 1,
          followupModeId: followUpMode.value,
          // obsImportId: dataFollowUp._id,
          //assignedAgentId:  dataFollowUp.assignedAgentId?dataFollowUp.assignedAgentId:"",
          mode: obsMode.value,
          leadId: dataFollowUp._id,
          futureFollowupModeId: futureFollowUpMode.value,
          followUpStatus: followUpStatus.value,
          followUpRemarks: followUpData.followUpRemarks,
          followUpTime: currentTime,
          followUpDate: currentDate,
          futureFollowUpDateTime: followUpData.futureFollowUpDate,
          futureFollowUpStrategy: followUpStrategy.value,
          recordAttachment: uploadInput,
          actionType: 1,
          clientReachStatus: radioOption.option,
        }
        console.log(submitFollowUp, "submitFollowUp")
        dispatch(myObsLeadAction.addFollowUp(submitFollowUp))
        setTimeout(() => {
          //dispatch(obsAction.loadObsList())
          dispatch(myObsLeadAction.loadMyObsList(searchValue))
          toast.success("Followup Added successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          })
          setFollowUpModal(false)
        }, 1000)
      } else {
        simpleValidator.current.showMessages()
        forceUpdate(1)
        setFollowUpModal(true)
      }
    }
  }
  const leadConveretedSubmit = () => {
    if (simpleLeadValidator.current.allValid()) {
      const submitFollowUp = {
        followupNo: 1,
        followupModeId: leadFollowupMode.value,
        mode: obsMode.value,
        leadId: dataFollowUp._id,
        followUpStatus: leadFollowUpStatus.value,
        followUpRemarks: followUpData.leadfollowUpRemarks,
        followUpTime: currentTime,
        followUpDate: currentDate,
        recordAttachment: uploadAttachment,
        actionType: 3,
        clientReachStatus: reachOption.option,
        crossPromotion: promotionData,
      }
      console.log(submitFollowUp, "submitFollowUp")
      dispatch(myObsLeadAction.addFollowUp(submitFollowUp))
      setTimeout(() => {
        // dispatch(obsAction.loadObsList())
        setObsMode({ label: "Other Brand Lead", value: 1 })
        dispatch(myObsLeadAction.loadMyObsList(searchValue))
        toast.success("Followup Added successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        setFollowUpModal(false)
      }, 1000)
    } else {
      simpleValidator.current.showMessages()
      leadForceUpdate(1)
      setFollowUpModal(true)
    }
  }
  const rejectedSubmit = () => {
    if (simpleRejectValidator.current.allValid()) {
      const submitFollowUp = {
        followupNo: 1,
        followupModeId: rejectedFollowupMode.value,
        mode: obsMode.value,
        leadId: dataFollowUp._id,
        rejectReason: rejectReason.value,
        redFlag: flagOption.option,
        followUpStatus: rejectedFollowUpStatus.value,
        followUpRemarks: followUpData.rejectfollowUpRemarks ,
        followUpTime: currentTime,
        followUpDate: currentDate,
        recordAttachment: attachmentFile,
        actionType: 2,
        clientReachStatus: checkOption.option,
      }
      console.log(submitFollowUp, "submitFollowUp")
      dispatch(myObsLeadAction.addFollowUp(submitFollowUp))
      setTimeout(() => {
        // dispatch(obsAction.loadObsList())
        dispatch(myObsLeadAction.loadMyObsList(searchValue))
        toast.success("Followup Added successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        setFollowUpModal(false)
      }, 1000)
    } else {
      simpleValidator.current.showMessages()
      rejectForceUpdate(1)
      setFollowUpModal(true)
    }
  }
  //dynamic radio button 1
  const [radioOption, setRadioOption] = useState({ option: "", checked: "" })

  const connectOptions = [
    { id: 1, option: "connected", label: "Connected" },
    { id: 2, option: "notConnected", label: "Not Connected" },
  ]

  const handleOptionsChange = (e, index) => {
    // console.log(connectOptions[index].option, "valueradio")
    let value = connectOptions[0].option
    setRadioOption({ option: value, checked: index })
  }

  //dynamic radio button 2
  const [checkOption, setCheckOption] = useState({ option: "", checked: "" })

  const checkOptions = [
    { id: 1, option: "connected", label: "Connected" },
    { id: 2, option: "notConnected", label: "Not Connected" },
  ]

  const handleCheckChange = (e, index) => {
    // console.log(checkOptions[index].option, "valueradio")
    let value = checkOptions[0].option
    setCheckOption({ option: value, checked: index })
  }

  //dynamic radio button 3
  const [reachOption, setReachOption] = useState({ option: "", checked: "" })

  const reachStatusOptions = [
    { id: 1, option: "connected", label: "Connected" },
    { id: 2, option: "notConnected", label: "Not Connected" },
  ]

  const handleReachStatusChange = (e, index) => {
    // console.log(reachStatusOptions[index].option, "valueradio")
    let value = reachStatusOptions[0].option
    setReachOption({ option: value, checked: index })
  }

  //Flag options
  const [flagOption, setFlagOption] = useState({ option: "", checked: "" })
  const flagOptions = [
    { id: 1, option: "yes", label: "Yes" },
    { id: 2, option: "no", label: "No" },
  ]

  const handleFlagChange = (e, index) => {
    // console.log(checkOptions[index].option, "valueradio")
    let value = flagOptions[0].option
    setFlagOption({ option: value, checked: index })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Obs"} breadcrumbItem={title} />
        </Container>
        {/**Filter Form Start */}
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Company"}</Label>
                      </div>
                      <Select
                        type="text"
                        name="company"
                        value={company}
                        onChange={(e) => setCompany(e)}
                        options={
                          obsMetaData.companyOptions
                            ? obsMetaData.companyOptions
                            : []
                        }
                        placeholder="Select Company"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Branch"}</Label>
                      </div>
                      <Select
                        type="text"
                        name="branch"
                        value={branch}
                        onChange={(e) => setBranch(e)}
                        options={branchOptions}
                        placeholder="Select Branch"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    {/* <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Sales Agent"}</Label>
                      </div>
                      <ReactSearchAutocomplete
                        name="salesAgent"
                        items={agentOptions}
                        value={employee}
                        type="autoComplete"
                        resultStringKeyName="label"
                        showIcon={false}
                        onSelect={(e) => setEmployee(e)}
                        onChange={(e) => setEmployee(e.target.value)}
                        placeholder="Enter Sales Agent"
                        fuseOptions={fuseOptions} // Search on both fields
                        styling={{
                          height: "34px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          boxShadow: "none",
                          hoverBackgroundColor: "#E40D8C",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Courier",
                          iconColor: "green",
                          clearIconMargin: "3px 8px 0 0",
                          zIndex: 10,
                        }}
                      />
                    </Col> */}
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Sales Urge"}</Label>
                      </div>
                      <Select
                        type="text"
                        name="salesUrge"
                        value={salesUrge}
                        onChange={(e) => setSalesUrge(e)}
                        options={[
                          { label: "Hot", value: "hot" },
                          { label: "Warm", value: "warm" },
                          { label: "Cold", value: "cold" },
                        ]}
                        placeholder="Select Branch"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Lead Source"}</Label>
                      </div>
                      <Select
                        type="text"
                        name="leadSource"
                        value={leadSource}
                        onChange={(e) => setLeadSource(e)}
                        options={
                          obsMetaData.sourceOptions
                            ? obsMetaData.sourceOptions
                            : []
                        }
                        placeholder="Select Source"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className="form-label"
                          htmlFor={"Lead From Date"}
                        >
                          {"Lead From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="fromDate"
                        value={myObsLeadData.fromDate}
                        max={myObsLeadData.toDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"To Date"}>
                          {"Lead To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="toDate"
                        value={myObsLeadData.toDate}
                        min={myObsLeadData.fromDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"Future Followup From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="followupFromDate"
                        value={myObsLeadData.followupFromDate}
                        max={myObsLeadData.followupToDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"To Date"}>
                          {"Future Followup To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="followupToDate"
                        value={myObsLeadData.followupToDate}
                        min={myObsLeadData.followupFromDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"Obs Future Followup From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="futureFollowupFromDate"
                        value={myObsLeadData.futureFollowupFromDate}
                        max={myObsLeadData.futureFollowupToDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"To Date"}>
                          {"Obs Future Followup To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="futureFollowupToDate"
                        value={myObsLeadData.futureFollowupToDate}
                        min={myObsLeadData.futureFollowupFromDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"Reject From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="rejectFromDate"
                        value={myObsLeadData.rejectFromDate}
                        max={myObsLeadData.rejectToDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"To Date"}>
                          {"Reject To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="rejectToDate"
                        value={myObsLeadData.rejectToDate}
                        min={myObsLeadData.rejectFromDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"Event From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="eventStartDate"
                        value={myObsLeadData.eventStartDate}
                        max={myObsLeadData.eventEndDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"Event To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="eventEndDate"
                        value={myObsLeadData.eventEndDate}
                        min={myObsLeadData.eventStartDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Sales Process Status"}
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="processStatus"
                        value={processStatus}
                        onChange={(e) => setProcessStatus(e)}
                        options={obsMetaData.processStatusOptions}
                        placeholder="Select Process Status"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Mode"}</Label>
                      </div>
                      <Select
                        type="text"
                        name="obsMode"
                        value={obsMode}
                        onChange={(e) => setObsMode(e)}
                        options={[
                          { label: "Other Brand Lead", value: 1 },
                          { label: "Reject Lead", value: 2 },
                        ]}
                        placeholder="Select Mode"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                  </Row>
                  <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                    <div className="filter-buttons" style={{ float: "right" }}>
                      <Button
                        type="button"
                        onClick={() => resetForm()}
                        className="btn btn-danger btn-label simple-form-Reset-btn"
                      >
                        <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                        Reset
                      </Button>
                      <Button
                        type="button"
                        onClick={() => handleFilter()}
                        className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                      >
                        <i className="bx bx-filter-alt label-icon"></i>
                        {btnLoader && btnLoader ? (
                          <ButtonSpinner />
                        ) : (
                          "Apply Filter"
                        )}{" "}
                      </Button>
                    </div>
                  </Col>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/**Table Start */}
        <Col md="12" lg="12" xl="12">
          <Card>
            <CardBody>
              <RemotePagination
                data={myObsLeadDataTable}
                page={page}
                sizePerPage={sizePerPage}
                totalSize={obs_datalist.totalDataCount}
                onTableChange={handleTableChange}
              />
            </CardBody>
          </Card>
        </Col>
        {loading ? (
          <Modal show={loading} style={{ width: "7%", margin: "18% 50%" }}>
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
        {downloadLoading ? (
          <Modal
            show={downloadLoading}
            style={{ width: "7%", margin: "18% 50%" }}
          >
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
        {btnLoading ? (
          <Modal show={btnLoading} style={{ width: "7%", margin: "18% 50%" }}>
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
        {followUpModal && (
          <Modal size="xl" show={followUpModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Followup
            </Modal.Header>
            <Modal.Body>
              {mode.value === "followup" ? (
                <>
                  <Row className="quote-head-content">
                    <Col md="6" lg="6" sm="12">
                      <div className="d-flex">
                        <p className="quote-head">
                          Current Followup
                          <span className="quote-info">
                            <i
                              style={{ color: "grey" }}
                              id="quoteInfo1"
                              aria-hidden="true"
                              className="fa fa-info-circle ms-1"
                            ></i>
                            <UncontrolledTooltip
                              placement="right"
                              target="quoteInfo1"
                            >
                              Current Followup
                            </UncontrolledTooltip>
                          </span>
                        </p>
                        <div style={{ width: "150px" }}>
                          <Select
                            name="mode"
                            value={mode}
                            onChange={(e) => setMode(e)}
                            options={[
                              { label: "Followup", value: "followup" },
                              {
                                label: "Lead Converted",
                                value: "leadConverted",
                              },
                              { label: "Rejected", value: "rejected" },
                            ]}
                            placeholder="Select Mode"
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="d-flex flex-row">
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className="form-label"
                          htmlFor={"Follow-Up-Date"}
                        >
                          {"Follow-Up-Date"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="followUpDate"
                        value={currentDate}
                        onChange={(e) => handleFollowUpChange(e)}
                        disabled
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Time"}>
                          {"Time"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="text"
                        placeholder="Select Date"
                        name="time"
                        value={currentTime}
                        onChange={(e) => handleFollowUpChange(e)}
                        disabled
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Follow-Up-Mode"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="followUpMode"
                        value={followUpMode}
                        onChange={(e) => setFollowUpMode(e)}
                        options={
                          obsMetaData ? obsMetaData.followUpModeOptions : []
                        }
                        placeholder="Select Follow Up Mode"
                        classNamePrefix="select2-selection"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "followUpMode",
                          followUpMode,
                          "required"
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Reach Status"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <div className="d-flex flex-row">
                        {connectOptions.map((item, index) => {
                          return (
                            <>
                              <div className="form-check form-check-inline">
                                <Input
                                  type="radio"
                                  key={item.id}
                                  name="Reach Status"
                                  value={radioOption.option}
                                  checked={radioOption.checked === index}
                                  onChange={(e) =>
                                    handleOptionsChange(e, index)
                                  }
                                />

                                <Label>{item.label}</Label>
                              </div>
                            </>
                          )
                        })}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "Reach Status",
                          radioOption.option,
                          "required"
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row className="d-flex flex-row mt-3">
                    <Col md="6" lg="6" sm="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Time"}>
                          {"Follow-Up-Remarks"} {""}{" "}
                          <span className="text-decoration-underline text-info">
                            History
                          </span>
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="textarea"
                        placeholder="Enter Follow Up Remarks"
                        name="followUpRemarks"
                        value={followUpData.followUpRemarks}
                        onChange={(e) => handleFollowUpChange(e)}
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "followUpRemarks",
                          followUpData.followUpRemarks,
                          "required"
                        )}
                      </div>
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Attachment (JPG/PNG)"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Button className=" btn btn-warning  position-relative fs-5">
                        <i className="fas fa-laptop"></i>

                        <Input
                          type="file"
                          name="uploadInput"
                          accept="application/pdf, audio/mp3 , image/jpeg"
                          // id="upload-btn"
                          multiple
                          onChange={(e) => uploadChange(e)}
                          style={{
                            position: "absolute",
                            fontSize: "50px",
                            opacity: 0,
                            right: 0,
                            top: 0,
                          }}
                        />
                        <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                          {fileLength ? fileLength : 0}
                        </span>
                      </Button>
                      <div className="text-decoration-underline text-danger">
                        {fileName ? fileName : ""}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "Attachment",
                          uploadInput,
                          "required"
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Follow-Up-Status"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="followUpStatus"
                        value={followUpStatus}
                        onChange={(e) => setFollowUpStatus(e)}
                        options={
                          obsMetaData ? obsMetaData.followUpStatusOptions : []
                        }
                        placeholder="Select Follow Up Status"
                        classNamePrefix="select2-selection"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleValidator.current.message(
                          "followUpStatus",
                          followUpStatus,
                          "required"
                        )}
                      </div>
                    </Col>
                  </Row>
                  <>
                    <Col md="12" lg="12" sm="12" className="quote-head-content">
                      <p className="quote-head">
                        Future Followup
                        <span className="quote-info">
                          <i
                            style={{ color: "grey" }}
                            id="quoteInfo1"
                            aria-hidden="true"
                            className="fa fa-info-circle ms-1"
                          ></i>
                          <UncontrolledTooltip
                            placement="right"
                            target="quoteInfo1"
                          >
                            Future Followup
                          </UncontrolledTooltip>
                        </span>
                      </p>
                    </Col>
                    <Row className="d-flex flex-row">
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Follow-Up-Date"}
                          >
                            {"Follow-Up-Date"}{" "}
                            <span className="required">*</span>
                          </Label>
                        </div>
                        <Input
                          type="datetime-local"
                          placeholder="Select Date"
                          name="futureFollowUpDate"
                          value={followUpData.futureFollowUpDate}
                          onChange={(e) => handleFollowUpChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Follow-Up-Mode"}{" "}
                            <span className="required">*</span>
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="futureFollowUpMode"
                          value={futureFollowUpMode}
                          onChange={(e) => setFutureFollowUpMode(e)}
                          options={
                            obsMetaData ? obsMetaData.followUpModeOptions : []
                          }
                          placeholder="Select Follow Up Mode"
                          classNamePrefix="select2-selection"
                        />
                        <div style={{ textTransform: "capitalize" }}>
                          {simpleValidator.current.message(
                            "futureFollowUpMode",
                            futureFollowUpMode,
                            "required"
                          )}
                        </div>
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Follow-Up-Strategy"}{" "}
                            <span className="required">*</span>
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="followUpStrategy"
                          value={followUpStrategy}
                          onChange={(e) => setFollowUpStrategy(e)}
                          options={
                            obsMetaData
                              ? obsMetaData.followUpStrategyOptions
                              : []
                          }
                          placeholder="Select Follow Up Strategy"
                          classNamePrefix="select2-selection"
                        />
                        <div style={{ textTransform: "capitalize" }}>
                          {simpleValidator.current.message(
                            "followUpStrategy",
                            followUpStrategy,
                            "required"
                          )}
                        </div>
                      </Col>
                    </Row>
                  </>
                </>
              ) : (
                ""
              )}
              {mode.value === "rejected" ? (
                <>
                  <Row className="quote-head-content">
                    <Col md="6" lg="6" sm="12">
                      <div className="d-flex">
                        <p className="quote-head">
                          Current Followup
                          <span className="quote-info">
                            <i
                              style={{ color: "grey" }}
                              id="quoteInfo1"
                              aria-hidden="true"
                              className="fa fa-info-circle ms-1"
                            ></i>
                            <UncontrolledTooltip
                              placement="right"
                              target="quoteInfo1"
                            >
                              Current Followup
                            </UncontrolledTooltip>
                          </span>
                        </p>
                        <div style={{ width: "150px" }}>
                          <Select
                            type="text"
                            name="mode"
                            value={mode}
                            onChange={(e) => setMode(e)}
                            options={[
                              { label: "Followup", value: "followup" },
                              {
                                label: "Lead Converted",
                                value: "leadConverted",
                              },
                              { label: "Rejected", value: "rejected" },
                            ]}
                            placeholder="Select Follow Up Mode"
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="d-flex flex-row">
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className="form-label"
                          htmlFor={"Follow-Up-Date"}
                        >
                          {"Follow-Up-Date"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="followUpDate"
                        value={currentDate}
                        onChange={(e) => handleFollowUpChange(e)}
                        disabled
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Time"}>
                          {"Time"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="text"
                        placeholder="Select Date"
                        name="time"
                        value={currentTime}
                        onChange={(e) => handleFollowUpChange(e)}
                        disabled
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Follow-Up-Mode"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="rejectedFollowupMode"
                        value={rejectedFollowupMode}
                        onChange={(e) => setRejectedFollowupMode(e)}
                        options={
                          obsMetaData ? obsMetaData.followUpModeOptions : []
                        }
                        placeholder="Select Follow Up Mode"
                        classNamePrefix="select2-selection"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleRejectValidator.current.message(
                          "rejectedFollowupMode",
                          rejectedFollowupMode,
                          "required"
                        )}
                        {isEmpty(rejectedFollowupMode) ? (
                          <span className="required">
                            The Followup Mode Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className={"form-label"}>
                        {"Reject Reason"}
                        <span className="required mx-1">*</span>
                      </Label>
                      <Select
                        type="text"
                        name="rejectReason"
                        value={rejectReason}
                        onChange={(e) => setRejectReason(e)}
                        options={
                          obsMetaData ? obsMetaData.rejectReasonOptions : []
                        }
                        placeholder="Select Reject Reason"
                        classNamePrefix="select2-selection"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleRejectValidator.current.message(
                          "Reject Reason",
                          rejectReason,
                          "required"
                        )}
                        {isEmpty(rejectReason) ? (
                          <span className="required">
                            The Reject Reason Field is required
                          </span>
                        ) : (
                          ""
                        )}</div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Red Flag"}
                          <span className="required mx-1">*</span>
                        </Label>
                      </div>

                      <div className="d-flex flex-row">
                        {flagOptions.map((item, index) => {
                          return (
                            <>
                              <div className="form-check form-check-inline">
                                <Input
                                  type="radio"
                                  key={item.id}
                                  name="flagOption"
                                  value={flagOption.option}
                                  checked={flagOption.checked === index}
                                  onChange={(e) => handleFlagChange(e, index)}
                                />

                                <Label>{item.label}</Label>
                              </div>
                            </>
                          )
                        })}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleRejectValidator.current.message(
                          "flagOption",
                          flagOption.option,
                          "required"
                        )}
                        {isEmpty(flagOption.option) ? (
                          <span className="required">
                            The Red Flag Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Reach Status"}
                          <span className="required">*</span>
                        </Label>
                      </div>

                      <div className="d-flex flex-row">
                        {checkOptions.map((item, index) => {
                          return (
                            <>
                              <div className="form-check form-check-inline">
                                <Input
                                  type="radio"
                                  key={item.id}
                                  name="Reach Status"
                                  value={checkOption.option}
                                  checked={checkOption.checked === index}
                                  onChange={(e) => handleCheckChange(e, index)}
                                />

                                <Label>{item.label}</Label>
                              </div>
                            </>
                          )
                        })}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleRejectValidator.current.message(
                          "Reach Status",
                          checkOption.option,
                          "required"
                        )}
                        {isEmpty(checkOption.option) ? (
                          <span className="required">
                            The Reach Status Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        {competitorCompanyAdd ? (
                          <Label className="event-label">
                            New Competitor Company
                          </Label>
                        ) : (
                          <Label className="event-label">
                            Competitor Company
                          </Label>
                        )}
                        <div
                          className="event-given-checkbox"
                          onClick={() => {
                            handleCompetitorCompanyTab()
                            setNewCompetitorCompany("")
                          }}
                        >
                          <Input
                            name="premium"
                            type="checkbox"
                            className="mt-1 event-given-input"
                            checked={competitorCompanyAdd ? true : false}
                            onClick={() => setNewCompetitorCompany("")}
                          />
                          <label className="event-given-input-text">
                            Add New
                          </label>
                        </div>
                      </div>
                      {competitorCompanyAdd ? (
                        <Input
                          name="newCompetitorCompany"
                          value={newCompetitorCompany}
                          onChange={(e) => setNewCompetitorCompany(e.target.value)}
                          placeholder="Enter Competitor Company"
                        />
                      ) : (
                        <Select
                          name="competitorCompany"
                          value={competitorCompany}
                          options={competitorCompanyOptions}
                          isSearchable
                          placeholder="Select Competitor Company"
                          onChange={(e) => setCompetitorCompany(e)}
                        />
                      )}
                      {competitorCompanyAdd ? (
                        <div
                          className="add-venue"
                          onClick={() => {
                            addCompetitorCompanyDetails()
                          }}
                        >
                          <span>Add</span>
                          {/* Add */}
                        </div>
                      ) : competitorCompanyAdded ? (
                        <div style={{ color: "green" }}>
                          <i className="fa fa-check add-new-venue">Added</i>
                        </div>
                      ) : (
                        ""
                      )}

                    </Col>
                  </Row>
                  <Row className="d-flex flex-row mt-3">
                    <Col md="6" lg="6" sm="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Time"}>
                          {"Follow-Up-Remarks"} {""}{" "}
                          <span className="required">*</span>
                          <span className="text-decoration-underline text-info">
                            History
                          </span>
                        </Label>
                      </div>
                      <Input
                        type="textarea"
                        placeholder="Enter Follow Up Remarks"
                        name="rejectfollowUpRemarks"
                        value={followUpData.rejectfollowUpRemarks}
                        onChange={(e) => handleFollowUpChange(e)}
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleRejectValidator.current.message(
                          "rejectfollowUpRemarks",
                          followUpData.rejectfollowUpRemarks,
                          "required"
                        )}
                        {isEmpty(followUpData.rejectfollowUpRemarks) ? (
                          <span className="required">
                            The Followup Remarks Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Attachment (JPG/PNG)"} <span className="required">*</span>
                        </Label>
                      </div>
                      <Button className=" btn btn-warning  position-relative fs-5">
                        <i className="fas fa-laptop"></i>

                        <Input
                          type="file"
                          name="attachmentFile"
                          accept="application/pdf, audio/mp3 , image/jpeg"
                          // id="upload-btn"
                          multiple
                          onChange={(e) => attachmentChange(e)}
                          style={{
                            position: "absolute",
                            fontSize: "50px",
                            opacity: 0,
                            right: 0,
                            top: 0,
                          }}
                        />
                        <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                          {attachFileLength ? attachFileLength : 0}
                        </span>
                      </Button>
                      <div className="text-decoration-underline text-danger">
                        {attachFileName ? attachFileName : ""}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleRejectValidator.current.message(
                          "Attachment",
                          attachmentFile,
                          "required"
                        )}
                        {isEmpty(attachmentFile) ? (
                          <span className="required">
                            The Attachment Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                 
                  </Row>
                </>
              ) : (
                ""
              )}
              {mode.value === "leadConverted" ? (
                <>
                  <Row className="quote-head-content">
                    <Col md="6" lg="6" sm="12">
                      <div className="d-flex">
                        <p className="quote-head">
                          Current Followup
                          <span className="quote-info">
                            <i
                              style={{ color: "grey" }}
                              id="quoteInfo1"
                              aria-hidden="true"
                              className="fa fa-info-circle ms-1"
                            ></i>
                            <UncontrolledTooltip
                              placement="right"
                              target="quoteInfo1"
                            >
                              Current Followup
                            </UncontrolledTooltip>
                          </span>
                        </p>
                        <div style={{ width: "150px" }}>
                          <Select
                            type="text"
                            name="mode"
                            value={mode}
                            onChange={(e) => setMode(e)}
                            options={[
                              { label: "Followup", value: "followup" },
                              {
                                label: "Lead Converted",
                                value: "leadConverted",
                              },
                              { label: "Rejected", value: "rejected" },
                            ]}
                            placeholder="Select Follow Up Mode"
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="d-flex flex-row">
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className="form-label"
                          htmlFor={"Follow-Up-Date"}
                        >
                          {"Follow-Up-Date"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="followUpDate"
                        value={currentDate}
                        onChange={(e) => handleFollowUpChange(e)}
                        disabled
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Time"}>
                          {"Time"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Input
                        type="text"
                        placeholder="Select Date"
                        name="time"
                        value={currentTime}
                        onChange={(e) => handleFollowUpChange(e)}
                        disabled
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Follow-Up-Mode"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="leadFollowupMode"
                        value={leadFollowupMode}
                        onChange={(e) => setLeadFollowupMode(e)}
                        options={
                          obsMetaData ? obsMetaData.followUpModeOptions : []
                        }
                        placeholder="Select Follow Up Mode"
                        classNamePrefix="select2-selection"
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleLeadValidator.current.message(
                          "leadFollowupMode",
                          leadFollowupMode,
                          "required"
                        )}
                        {isEmpty(leadFollowupMode) ? (
                          <span className="required">
                            The Lead FollowupMode Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Reach Status"}
                          <span className="required">*</span>
                        </Label>
                      </div>
                      <div className="d-flex flex-row">
                        {reachStatusOptions.map((item, index) => {
                          return (
                            <>
                              <div className="form-check form-check-inline">
                                <Input
                                  type="radio"
                                  key={item.id}
                                  name="Reach Status"
                                  value={reachOption.option}
                                  checked={reachOption.checked === index}
                                  onChange={(e) =>
                                    handleReachStatusChange(e, index)
                                  }
                                />

                                <Label>{item.label}</Label>
                              </div>
                            </>
                          )
                        })}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleLeadValidator.current.message(
                          "Reach Status",
                          reachOption.option,
                          "required"
                        )}
                        {isEmpty(reachOption.option) ? (
                          <span className="required">
                            The Reach Status Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                
                  </Row>
                  <Row className="d-flex flex-row mt-3">
                    <Col md="6" lg="6" sm="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Time"}>
                          {"Follow-Up-Remarks"} {""}{" "}
                          <span className="required">*</span>
                          <span className="text-decoration-underline text-info">
                            History
                          </span>
                        </Label>
                      </div>
                      <Input
                        type="textarea"
                        placeholder="Enter Follow Up Remarks"
                        name="leadfollowUpRemarks"
                        value={followUpData.leadfollowUpRemarks}
                        onChange={(e) => handleFollowUpChange(e)}
                      />
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleLeadValidator.current.message(
                          "leadfollowUpRemarks",
                          followUpData.leadfollowUpRemarks,
                          "required"
                        )}
                        {isEmpty(followUpData.leadfollowUpRemarks) ? (
                          <span className="required">
                            The Lead FollowUpRemarks Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Attachment (JPG/PNG)"} <span className="required">*</span>
                        </Label>
                      </div>
                      <Button className=" btn btn-warning  position-relative fs-5">
                        <i className="fas fa-laptop"></i>

                        <Input
                          type="file"
                          name="uploadAttachment"
                          accept="application/pdf, audio/mp3 , image/png,image/jpeg"
                          // id="upload-btn"
                          multiple
                          onChange={(e) => fileChange(e)}
                          style={{
                            position: "absolute",
                            fontSize: "50px",
                            opacity: 0,
                            right: 0,
                            top: 0,
                          }}
                        />
                        <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                          {uploadFileLength ? uploadFileLength : 0}
                        </span>
                      </Button>
                      <div className="text-decoration-underline text-danger">
                        {uploadFileName ? uploadFileName : ""}
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        {simpleLeadValidator.current.message(
                          "Attachment",
                          uploadAttachment,
                          "required"
                        )}
                        {isEmpty(uploadAttachment) ? (
                          <span className="required">
                            The Attachment Field is required
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row className="d-flex flex-row">
                    <Col md="9" lg="9" sm="12" className="quote-head-content">
                      <p className="quote-head">
                        Cross Promotion
                        <span className="quote-info">
                          <i
                            style={{ color: "grey" }}
                            id="quoteInfo1"
                            aria-hidden="true"
                            className="fa fa-info-circle ms-1"
                          ></i>
                          <UncontrolledTooltip
                            placement="right"
                            target="quoteInfo1"
                          >
                            Cross Promotion
                          </UncontrolledTooltip>
                        </span>
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12">
                      <Button
                        className="btn btn-info"
                        style={{ float: "right" }}
                        onClick={() => addCrossPromotion()}
                      >
                        Add <i className="fa solid fa-plus"></i>
                      </Button>
                    </Col>
                  </Row>
                  {crossPromotionData &&
                    crossPromotionData.length > 0 &&
                    crossPromotionData.map((item, index) => {
                      const companyArray = crossPromotionData.map(
                        (m) => m.companyId
                      )
                      const companyValue = companyArray.toString()
                      console.log(companyValue, "companyvalue")

                      const companyIds = companyValue.split(",")
                      console.log(companyIds, "companyIds")

                      const followupbranchOptions =
                        !isEmpty(obsMetaData) &&
                        obsMetaData.branchOptions.filter(
                          (branch) =>
                            companyIds.includes(branch.companyId) &&
                            (!item.companyId ||
                              item.companyId === branch.companyId)
                        )

                      const serviceOptions = !isEmpty(obsMetaData) &&
                        obsMetaData.serviceOptions.filter((service) => {
                          // Checking  if any company ID in service
                          const hasMatchingCompany = service.companyId.some((id) =>
                            companyIds.includes(id)
                          )
                          //my Check for item.companyId 
                          const isItemCompanyIdMatch =
                            !item.companyId || service.companyId.includes(item.companyId)

                          return hasMatchingCompany && isItemCompanyIdMatch
                        })
                      return (
                        <Row key={index}>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Company"} <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="companyId"
                              value={
                                item.companyId
                                  ? {
                                    value: item.companyId,
                                    label: item.company,
                                  }
                                  : ""
                              }
                              onChange={(e) =>
                                modalChange(e, index, "companyId")
                              }
                              options={
                                obsMetaData ? obsMetaData.companyOptions : []
                              }
                              placeholder="Select Company"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleLeadValidator.current.message(
                                "company",
                                item.companyId,
                                "required"
                              )}
                              {isEmpty(item.companyId) ? (
                                <span className="required">
                                  The Company Field is required
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Branch"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="branchId"
                              value={
                                item.branchId
                                  ? {
                                    value: item.branchId,
                                    label: item.branch,
                                  }
                                  : ""
                              }
                              onChange={(e) =>
                                modalChange(e, index, "branchId")
                              }
                              options={followupbranchOptions}
                              placeholder="Select Branch"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleLeadValidator.current.message(
                                "branch",
                                item.branchId,
                                "required"
                              )}
                              {isEmpty(item.branchId) ? (
                                <span className="required">
                                  The Branch Field is required
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="13" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Service"} <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="serviceId"
                              value={
                                item.serviceId
                                  ? {
                                    value: item.serviceId,
                                    label: item.service,
                                  }
                                  : ""
                              }
                              onChange={(e) =>
                                modalChange(e, index, "serviceId")
                              }
                              options={serviceOptions}
                              placeholder="Select Service"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleLeadValidator.current.message(
                                "service",
                                item.serviceId,
                                "required"
                              )}
                              {isEmpty(item.serviceId) ? (
                                <span className="required">
                                  The Service is required
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </Col>
                          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Sales Urge"}
                                <span className="required">*</span>
                              </Label>
                            </div>
                            <Select
                              type="text"
                              name="convertSalesUrgeId"
                              value={
                                item.convertSalesUrgeId
                                  ? {
                                    value: item.convertSalesUrgeId,
                                    label: item.convertSalesUrge,
                                  }
                                  : ""
                              }
                              onChange={(e) =>
                                modalChange(e, index, "convertSalesUrgeId")
                              }
                              options={
                                [{ label: "Hot", value: "hot" }, { label: "Warm", value: "warm" }, { label: "Cold", value: "cold" }]
                              }
                              placeholder="Select Follow Up Mode"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleLeadValidator.current.message(
                                "SalesUrge",
                                item.convertSalesUrgeId,
                                "required"
                              )}
                              {isEmpty(item.convertSalesUrgeId) ? (
                                <span className="required">
                                  The Sales Urge is required
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </Col>
                          <Col lg="2" md="2" sm="12" xs="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Remarks"} <span className="required">*</span>
                              </Label>
                            </div>

                            <Input
                              type="text"
                              name="followUpRemarks"
                              value={item.followUpRemarks}
                              placeholder="Enter Remarks"
                              onChange={(e) =>
                                modalChange(e, index, "followUpRemarks")
                              }
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              {simpleLeadValidator.current.message(
                                "Remarks",
                                item.followUpRemarks,
                                "required"
                              )}
                              {isEmpty(item.followUpRemarks) ? (
                                <span className="required">
                                  The Remarks is required
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </Col>

                          <Col
                            lg="1"
                            md="1"
                            sm="12"
                            xs="12"
                            className="float-right"
                          >
                            <i
                              className="fa fa-times mt-5 font-size-20"
                              style={{ color: "#db4343", cursor: "pointer" }}
                              onClick={() => removeCrossPromotion(index)}
                            ></i>
                          </Col>
                        </Row>
                      )
                    })}
                </>
              ) : (
                ""
              )}
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => {
                  setFollowUpModal(false)
                  setCheckOption({ option: "", checked: "" })
                  setRadioOption({ option: "", checked: "" })
                  setReachOption({ option: "", checked: "" })
                  setFileName("")
                  setFileLength("")
                  setAttachFileName("")
                  setAttachFileLength("")
                  setUploadFileName("")
                  setUploadFileLength("")
                }}
              >
                Cancel
              </Button>
              {mode.value === "followup" ? (
                <>
                  <Button
                    type="button"
                    variant="primary"
                    className="btn btn-success"
                    onClick={() => {
                      submitCrossPromotion()
                    }}
                  >
                    Submit
                  </Button>
                </>
              ) : mode.value === "rejected" ? (
                <>
                  <Button
                    type="button"
                    variant="primary"
                    className="btn btn-success"
                    onClick={() => {
                      rejectedSubmit()
                    }}
                  >
                    Submit
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    type="button"
                    variant="primary"
                    className="btn btn-success"
                    onClick={() => {
                      leadConveretedSubmit()
                    }}
                  >
                    Submit
                  </Button>
                </>
              )}
            </Modal.Footer>
          </Modal>
        )}
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        {followUpHistoryModal && (
          <Modal size="xl" show={followUpHistoryModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Followup History
            </Modal.Header>
            <Modal.Body>
              <Col md="12" lg="12" xl="12" className="mt-5">
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <th>S.No</th>

                      <th>Followup Date And Time</th>
                      <th>Followup Mode</th>

                      <th>Reach Status</th>
                      <th>Followup Remarks</th>
                      <th>Followup Status</th>

                      <th>Attachment</th>
                      <th>Future Followup Date And Time</th>
                      <th>Future Followup</th>

                      <th>Followup Strategy</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(followup_list) && followup_list.length > 0 ? (
                      followup_list.map((item, index) => {
                        var attachments = !isEmpty(item.recordAttachment)
                          ? item.recordAttachment.map((f) => f)
                          : []

                        // console.log(str, "string attachments")
                        const fileUrl = isEmpty(item.recordAttachment)
                          ? ""
                          : item.recordAttachment.map((data) =>
                            data.split(".").pop()
                          )
                        // console.log(fileUrl, "string attachments")
                        // console.log(attachments, "attachment with alpha url")
                        const colorCode =
                          !isEmpty(obsMetaData) &&
                          obsMetaData.processStatusOptions &&
                          obsMetaData.processStatusOptions.length > 0 &&
                          obsMetaData.processStatusOptions.find(
                            (_) => _.value === item.processStatus
                          ) &&
                          obsMetaData.processStatusOptions.find(
                            (_) => _.value === item.processStatus
                          ).colorCode

                        const followpDate = !isEmpty(item.followUpDate)
                          ? moment(item.followUpDate)
                            .subtract(5, "hours")
                            .subtract(30, "minutes")
                            .format(dateFormat)
                          : "--"
                        const futureFollowUpDateTime = !isEmpty(
                          item.futureFollowUpDateTime
                        )
                          ? moment(item.futureFollowUpDateTime)
                            .subtract(5, "hours")
                            .subtract(30, "minutes")
                            .format(`${dateFormat} hh:mm A`)
                          : "--"

                        return (
                          <>
                            <tr key={item._id}>
                              <td>{index + 1}</td>

                              <td>{followpDate + " " + item.followUpTime}</td>
                              <td>{item.followupModeId}</td>
                              <td>{item.clientReachStatus}</td>
                              <td>{item.followUpRemarks}</td>
                              <td>
                                {!isEmpty(item.followUpStatus)
                                  ? item.followUpStatus
                                  : "--"}
                              </td>
                              <td>
                                {fileUrl[0] === "jpeg" ||
                                  fileUrl[0] === "jpg" ||
                                  fileUrl[0] === "png" ? (
                                  <a
                                    onClick={() =>
                                      window.open(attachments, "_blank")
                                    }
                                  >
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        color: "#E40D8C",
                                      }}
                                    >
                                      View
                                    </span>
                                  </a>
                                ) : fileUrl[0] === "mp3" ||
                                  fileUrl[0] === "m4a" ||
                                  fileUrl[0] === "mp4" ? (
                                  <a href={attachments}>
                                    <audio controls>
                                      <source
                                        src={attachments}
                                        type="audio/mpeg"
                                      />
                                      Your browser does not support the audio
                                      element.
                                    </audio>
                                  </a>
                                ) : isEmpty(attachments) ? (
                                  "--"
                                ) : (
                                  "--"
                                )}
                              </td>
                              <td>{futureFollowUpDateTime}</td>
                              <td>
                                {!isEmpty(item.futureFollowupModeId)
                                  ? item.futureFollowupModeId
                                  : "--"}
                              </td>
                              <td>{item.futureFollowUpStrategy}</td>
                              <td>
                                <button
                                  style={{
                                    background: colorCode,
                                    border: "none",
                                    cursor: "pointer",
                                    color: "white",
                                    padding: "2px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  {item.processStatusName}
                                </button>
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={13} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setFollowUpHistoryModal(false)}
              >
                Close
              </Button>
              {/* <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => setFollowUpHistoryModal(false)}
              >
                Submit
              </Button> */}
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </React.Fragment>
  )
}
MyObsLeadDetails.propTypes = {
  dispatch: PropTypes.func,
  //recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  name: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  FlagExportExcel: PropTypes.any,
  FlagImportInward: PropTypes.any,
  FlagTableSearch: PropTypes.any,
  columns: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MyObsLeadDetails)
)
